<template>
	<div>
		<div class="card" id="card" v-on:click="clickFunction('' + slug + '', apply, '' + status + '')">

			<div v-if="iconUrl !== 'no'" class="card-container-icon text-right">
									
				<span v-if="status === 'LIVE'" class="text-right">
					<div class="pulse"></div>
					<span class="challenge-status">
						{{status}}
					</span>
				</span>

				<span v-else-if="status === 'VOTING'" class="text-right">
					<div class="pulse-voting"></div>
					<span class="challenge-status-voting">
						{{status}}
					</span>
				</span>

				<span v-else-if="status === 'ENDED'" class="text-right">
					<div class="pulse-ended"></div>
					<span class="challenge-status-ended">
						{{status}}
					</span>
				</span>
			
				<div class="badge-container text-left"><span class="badge badge-success text-left">{{category}}</span></div>
				
				<center>
					<img class="img_icon" :src='iconUrl' alt="challenge icon" />
				
				</center>
			</div>

			<div v-else-if="iconUrl === 'no'">
				<div class="background-img text-right" :style="'background:url(' + imgUrl + ') center / cover; height:150px; margin-bottom:15px;'">
					<span v-if="status === 'LIVE'" class="text-right">
						<div class="pulse"></div>
						<span class="challenge-status">
							{{status}}
						</span>
					</span>

					<span v-else-if="status === 'VOTING'" class="text-right">
						<div class="pulse-voting"></div>
						<span class="challenge-status-voting">
							{{status}}
						</span>
					</span>

					<span v-else-if="status === 'ENDED'" class="text-right">
						<div class="pulse-ended-img"></div>
						<span class="challenge-status-ended-img">
							{{status}}
						</span>
					</span>
				
					<div class="badge-container text-left"><span class="badge badge-success text-left">{{category}}</span></div>
					
				</div>
				
			</div>
			
			<center><h4 class="card-title">{{title}}</h4></center>

			<div class="card-text text-left">
				{{supporting}}
			</div>
			
			<div class="card-btn text-left">
				<a v-if="status === 'LIVE' " class="btn-text">{{ctaText}}<i class="right"></i></a>
				<a v-else-if="status === 'VOTING' " class="btn-text">VOTE NOW<i class="right"></i></a>
				<a v-else-if="status === 'ENDED' " class="btn-text">VIEW RESULTS<i class="right"></i></a>
			</div>
		
		</div>
	</div>
    
</template>

<script>
export default {
	name: 'ChallengeCard', 
	props: {
		clickFunction: Function,
		challengeObj: Object,
		status: String,
		slug: String,
		category: String,
		iconUrl: String,
		title: String,
		imgUrl: String,
		supporting: String,
		ctaFunction: Function,
		ctaText: String,
		apply: Boolean
	}
}
</script>


<style>


	.card {
		margin-top:20px; 
		margin-bottom:20px; 
		padding-top:0px;
		margin-right: 6.25%;
		margin-left: 6.25%;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(1, 2, 2, 0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
		cursor:pointer;
		border-radius: 10px;
	}

	.card:hover {
		box-shadow: 12px 15px 20px 0px rgba(46,61,73,0.2);
	}

	.card-container-icon {
		padding-top:20px;
	}

	.background-img {
		padding-top:20px;
	}

	.challenge-status {
		margin-right:10%;
		color:red;
		font-size:12px;
	}

	.challenge-status-voting {
		margin-right:10%;
		color:#6c63ff;
		font-size:12px;
	}

	.challenge-status-ended {
		margin-right:10%;
		color:#aaa;
		font-size:12px;
	}

	.challenge-status-ended-img {
		margin-right:10%;
		color:#eee;
		font-size:12px;
	}


	.card-title {
		color:#333; 
		font-size:1.1rem;
		margin-top:10px;
		margin-bottom:30px;
		font-weight: 300;
	}

	.img_icon {
		padding-top:10px; 
		padding-bottom:10px;
		height:90px;
		width:140px;
	}

	div.card-text.text-left {
		margin-left: 8%;
		margin-right:8%;
		margin-top:8%;
		font-size:0.9rem;
		font-weight: 300;
		color:#555;
	}


	span.badge.badge-success.text-left {
		border-top-right-radius: 0.25rem;
    	border-bottom-right-radius: 0.25rem;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		margin-bottom:10px;
	}
	

	.card-btn {
		background-color: #fff;
		margin-left:8%;
		margin-top:40px;
		margin-bottom: 10px;
		cursor: pointer;
		font-size: 0.9rem;
		font-weight: 500;
	}

	i.right {
		border: solid #f25792;
		border-width: 0 2px 2px 0;
		display: inline-block;
		padding:3px;
		margin-bottom: 1px;
		margin-left: 10px;
	}

	.right {
		transform: rotate(-45deg);
		-webkit-transform: rotate(-45deg);
	}

	a.btn-text {
		color:#f25792 !important;
	}

	.mdc-card__media {
		background-color:#fff;
	}


	.pulse {
		display: inline-block;
		margin-left:8px;
		margin-right:8px;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background: red;
		cursor: pointer;
		box-shadow: 0 0 0 rgba(204,169,44, 0.4);
		animation: pulse 1s infinite;
	}

	.pulse:hover {
		animation: none;
	}

	.pulse-voting {
		display: inline-block;
		margin-left:8px;
		margin-right:8px;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background: #6C63FF;
		cursor: pointer;
		box-shadow: 0 0 0 rgba(204,169,44, 0.4);
		
	}

	.pulse-voting:hover {
		animation: none;
	}

	.pulse-voting-white {
		display: inline-block;
		margin-left:10px;
		margin-right:10px;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background: #fff;
		cursor: pointer;
		box-shadow: 0 0 0 rgba(204,169,44, 0.4);
		
	}

	.pulse-voting-white:hover {
		animation: none;
	}

	.pulse-ended {
		display: inline-block;
		margin-left:8px;
		margin-right:8px;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background: #999;
		cursor: pointer;
		box-shadow: 0 0 0 rgba(204,169,44, 0.4);
		
	}

	.pulse-ended:hover {
		animation: none;
	}

	.pulse-ended-img {
		display: inline-block;
		margin-left:8px;
		margin-right:8px;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		background: #eee;
		cursor: pointer;
		box-shadow: 0 0 0 rgba(204,169,44, 0.4);
		
	}

	.pulse-ended-img:hover {
		animation: none;
	}

	@-webkit-keyframes pulse {
		0% {
			-webkit-box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
		}
		70% {
			-webkit-box-shadow: 0 0 0 10px rgba(204,169,44, 0);
		}
		100% {
			-webkit-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
		}
	}
	
	@keyframes pulse {
		0% {
			-moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
			box-shadow: 0 0 0 0 rgba(204,169,44, 0.4);
		}
		70% {
			-moz-box-shadow: 0 0 0 10px rgba(204,169,44, 0);
			box-shadow: 0 0 0 10px rgba(204,169,44, 0);
		}
		100% {
			-moz-box-shadow: 0 0 0 0 rgba(204,169,44, 0);
			box-shadow: 0 0 0 0 rgba(204,169,44, 0);
		}
	}

</style>
